import { render, staticRenderFns } from "./myguests.vue?vue&type=template&id=45f2d201&"
import script from "./myguests.vue?vue&type=script&lang=js&"
export * from "./myguests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports